import {
    ItemCondition,
    TemperatureExcursionIdentifier,
    TemperatureExcursionLocation,
    TemperatureIssueType
} from '../../../../enums';

export interface ITemperatureSubtypeInt {
    issueType: TemperatureIssueType;
    identificationDate: Date;
    identificationLocation: TemperatureExcursionLocation;
    exactLocation: string;
    identificationBy: TemperatureExcursionIdentifier;
    temperatureRequirementsIncluded: boolean;
    issueNotedInDocumentation: boolean;
    issueNotNotedExplanation?: string;
    claimFiled: boolean;
    explanation: string;
    conditionOfItem: ItemCondition[];
    carrierTrackingNumber: string;
}
